import React, { useState, useEffect } from "react";
import { headingStyle } from "./styles";

const Typewriter = ({ text = "", speed = 100, style }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    setDisplayedText("");

    if (!text) {
      return undefined;
    }

    let index = 1;
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, index));

      if (index >= text.length) {
        clearInterval(interval);
      }

      index++;
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return <h1 style={{ ...headingStyle, ...style }}>{displayedText}</h1>;
};

export default Typewriter;
